import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import { GuestIdentityVerificationStatus } from 'uplisting-frontend/models/occasion';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class GuestIdentityVerificationModel extends Model {
  @attr('string') status!: GuestIdentityVerificationStatus;

  @cached
  get succeeded(): boolean {
    return [
      GuestIdentityVerificationStatus.succeeded,
      GuestIdentityVerificationStatus.verified,
    ].includes(this.status);
  }

  @belongsTo('booking', { inverse: 'guestIdentityVerification', async: false })
  booking!: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'guest-identity-verification': GuestIdentityVerificationModel;
  }
}
